/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * 'bookable' = has an available slot (can be booked now); 'none' = approved but not bookable yet (no slots, or all past / full / busy). Absent on admin listings filtered to a non-approved status (statusFilter), which skip the availability check.
 */
export enum ActivitySearchResultAvailability {
  bookable = 'bookable',
  none = 'none'
}
